export default "__VITE_ASSET__7fdf3397__"